/**
 this file hold generic methods which can be used on cross-application level
 */
import React from "react";

// let getUserLocation;

export const getUserLocation = async () => {

    let oResult = { lat: 0, lng:0, locAvailable:false },
        oPosition;

    try {

      if (!navigator.geolocation) { 
        oResult.locAvailable = false;
        return oResult;
      }

        oPosition   =  await _getCoordinates();

        oResult.lat = oPosition.coords.latitude;
        oResult.lng = oPosition.coords.longitude;
        oResult.locAvailable = true;

        return(oResult);

    } catch(e) {
        oResult.locAvailable = false;
        return(oResult);
    }
}

// types: default: dat, loc: geoLocation
export const createURLQuery = async (oParams, iPage) => {
    let oObject = {},
        oCoords,
        oResult;

    switch(oParams.type) {

        case 'dat':
            oObject.type = 'dat';
            oObject.page = iPage;
           
        break;

        case 'loc':
            // oCoords = await getUserLocation();

            oObject.type =  'loc';
            oObject.lat  = oParams.lat;
            oObject.lng  = oParams.lng;
            oObject.page = iPage;
        break;

        case 'prc':
          oObject.type = 'prc';
          oObject.page = iPage;
        break;

        default: //
    }

    // media size for obj det route:
    if(oParams.meds) { oObject.meds = oParams.meds }
    
    oResult = new URLSearchParams(oObject)

    return oResult;
}

// display or hide page components based on route.(screen size check is handled with sx prop, on component level)
export const handleCompDisplay = (sComponent, currPath) => {

        let disp;

        switch(sComponent) {

            case 'tlbr.backBtn':
                switch(currPath) {
                    case '/': disp = 'none'; break;
                    default : disp= 'flex'
                }
            break;

            case 'tlbr.favBtn':
                switch(currPath) {
                    case '/'         : disp = 'flex'; break;
                    case '/favorites': disp = 'none'; break;
                    case '/about'    : disp = 'none'; break;
                    case '/contact'  : disp = 'none'; break;
                    case '/newItem'   : disp = 'none'; break;
                    default: //
                }
            break;

            case 'tlbr.fltBtn':
                switch(currPath) {
                    case '/'         : disp = 'flex'; break;
                    case '/favorites': disp = 'none'; break;
                    case '/about'    : disp = 'none'; break;
                    case '/contact'  : disp = 'none'; break;
                    case '/newItem'   : disp = 'none'; break;
                    default: //
                }
            break;

            case 'sideBar':
                switch(currPath) {
                    case '/'         : disp = 'flex'; break;
                    case '/favorites': disp = 'none'; break;
                    case '/about'    : disp = 'none'; break;
                    case '/contact'  : disp = 'none'; break;
                    case '/newItem'   : disp ='none'; break;
                    default: //
                }
            break;

            default: //


        }
        return disp;
    

}



/************************************************************
* INTERNAL METHODS
 ************************************************************/

function _getCoordinates() {
  return new Promise((resolve, reject) => {

    if ("geolocation" in navigator) {
      // Pass resolve and reject to the callback and error handlers
      navigator.geolocation.getCurrentPosition(resolve, reject);
    } else {
      reject("Geolocation is not supported by your browser");
    }
  });
}

